import { render, staticRenderFns } from "./RouteDetailPage.vue?vue&type=template&id=a813dcbc&scoped=true"
import script from "./RouteDetailPage.vue?vue&type=script&lang=js"
export * from "./RouteDetailPage.vue?vue&type=script&lang=js"
import style0 from "./RouteDetailPage.vue?vue&type=style&index=0&id=a813dcbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a813dcbc",
  null
  
)

export default component.exports